import React, { useState, useEffect } from "react";

import * as modalConstants from "../../../constants/modal.constants.js";
import ForgotPassword from "./ForgotPassword/ForgotPassword.jsx";
import SignUpForm from "./SignUp/SignUpForm.jsx";
import AccountSelection from "./AccountSelection/AccountSelection.jsx";
import { useLocation } from "react-router-dom";
import LoginForm from "./LoginForm.jsx";

const Modal = (props) => {
  const location = useLocation();
  const initialFormSelect =
    location?.state?.formSelect ??
    props.formType ??
    modalConstants.ACCOUNT_SELECTION;

  // To manage diffrent forms in modal creating state of forms and render the one you want to show
  const [formSelect, setFormSelect] = useState(initialFormSelect);

  useEffect(() => {
    if (location?.state) {
      const { formSelect } = location.state;

      if (formSelect) {
        setFormSelect(formSelect);
      }
    }
  }, [location]); // Re-run effect if location changes

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "unset");
  }, []);

  return (
    <>
      {formSelect === modalConstants.ACCOUNT_SELECTION ? (
        <AccountSelection />
      ) : (
        <div
          className={`${props.isAllowModal ? "black-drop" : "no-black-drop"}`}
        >
          <div className={`modal-forms-con`}>
            {formSelect === modalConstants.FORGOT_PASSWORD_FORM && (
              <ForgotPassword
                isAllowModal={props.isAllowModal}
                isPage={props.isPage}
                setIsModalOpen={props.setIsModalOpen}
                setFormSelect={setFormSelect}
                showBackButton={props.showBackButton}
              />
            )}
            {formSelect === modalConstants.SIGNUP_FORM && (
              <SignUpForm
                isAllowModal={props.isAllowModal}
                isPage={props.isPage}
                setIsModalOpen={props.setIsModalOpen}
                setFormSelect={setFormSelect}
                showBackButton={props.showBackButton}
              />
            )}
            {formSelect === modalConstants.LOGIN_FORM && (
              <LoginForm
                isAllowModal={props.isAllowModal}
                setFormSelect={setFormSelect}
                setIsModalOpen={props.setIsModalOpen}
                showBackButton={props.showBackButton}
              />
            )}
            {/* shutterb signup will be redirected */}
          </div>
        </div>
      )}
    </>
  );
};

export default Modal;
